var map = {
	"./en.ai_workforce.json": "bc73",
	"./en.colors.json": "eaec",
	"./en.jobs.json": "2ee5",
	"./en.json": "edd4",
	"./pt.ai_workforce.json": "c71c",
	"./pt.colors.json": "00a5",
	"./pt.jobs.json": "bf2d",
	"./pt.json": "5d67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";